import axios from 'axios';
import './axiosinterceptorpagoprueba';
export const PASARELA = process.env.VUE_APP_URLPASARELA;

export const Prueba = {
  enviar_pago(payload) {
    return axios.post(PASARELA + "/checkout", payload)
  },
}
